
import { useState } from 'react';
import { useI18n } from '../utils/lni18n';
import { useMemo } from 'react';
import { useAtom } from 'jotai';
import {  useNavigate, useParams } from 'react-router-dom';
import LnIcon from 'src/components/LnIcon';
import courseService, { oneCourseatom } from './CourseService';
import LockedReason from 'src/components/LockedReason';
import { LockReason } from 'src/types';
import { CourseEditResponse } from './domain/CourseEditModel';
import { urlService } from 'src/services/NavService';
import { useCurrentUser } from 'src/services/user/userService';
import { useConfirm } from 'src/components/Modalservice/UseConfirm';
import WaitRipple from 'src/components/WaitRipple';

export default function CourseComponentHeader() {

    const navigate = useNavigate();
    const { currentUser } = useCurrentUser();
    const { courseId } = useParams();
    const [course] = useAtom(
        useMemo(() => oneCourseatom(courseId || ""), [courseId]));
    const confirm = useConfirm();
    const { languageService: t } = useI18n();
    const [prepPreview, setprepPreview] = useState(false);


    if( !course ){
        return <WaitRipple />;
    }

    const unlock = () => {
        courseService.loadCourse(course!.Course.Id, true);
    }

    let openAgainButton = null;
    if (course?.Locked?.Reason === LockReason.LockedBySelf) {
        openAgainButton = <button className='mt-3 ml-3 btn btn-warning btn-small' onClick={unlock} >{t.getText("yes")}</button>;
    }
    function closeCourse(course: CourseEditResponse): void {

        if (course.Locked || !course.IsDirty) {
            doCloseCourse(course.Course.Id);
            return;
        }

        confirm("md", t.getText("close.editor"),
                <div className="preserve-white" >{t.getText("publish.before.close")}</div>)
            .then(async (res: boolean) => {
                if (res) {
                    navigate(urlService.urlToCourse(courseId!, "publish"));
                }
                else {
                    doCloseCourse(course.Course.Id);
                }
            }).catch((e: Error) => {/* no need to catch */});


    }

    async function doCloseCourse(courseId: string) {
        const nextCourseId = await courseService.closeCourse(courseId);
        if (nextCourseId) {
            navigate(urlService.urlToCourse(nextCourseId));
        }
        else {
            navigate(`/`);
        }
    }

    async function previewCourse() {
        if (!currentUser) return;
        
        try {
            setprepPreview(true);
            const url = await courseService.previewCourse(course.Course.Id, currentUser!.Id);
            if (url !== null) {
                window.open(url, '_blank');
            }
        }
        finally {
            setprepPreview(false);
        };
    }

    

    return  <div className="card-box-title card-title ">
                    <div className='w-100 d-flex align-items-start'>
                        <h3>
                            {course.Course.Name}
                            {course.Locked && <LnIcon className='ml-3' name="locked" />}
                        </h3>


                        <div className='ml-auto d-flex'>
                            {course.Locked && <LockedReason info={course.Locked} >{openAgainButton}</LockedReason>}
                            <div>
                                <button disabled={prepPreview} onClick={previewCourse} className="ml-3 btn btn-primary btn-small" type="button">
                                    {prepPreview ? t.getText("wait.moment") : t.getText("preview")}
                                </button>
                            </div>
                            <button onClick={(e) => closeCourse(course)} className="ml-5 btn btn-link" type="button">
                                <LnIcon name="close" />
                            </button>

                        </div>
                    </div>
                </div>                



}